module.exports = __webpack_public_path__ + "static/media/flashCardDefault2.6069efcd.png";